import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {OccupationalProfileInfoPackageComponent} from './occupational-profile-info-package.component';

@NgModule({
    imports: [
        CommonModule
    ],
    providers: [
    ],
    declarations: [
        OccupationalProfileInfoPackageComponent
    ],
    exports: [
        OccupationalProfileInfoPackageComponent
    ]
})

export class InfoPackageModule {

}
